import angular from 'angular';
import AssetLoaderService from "./asset-loader.service";

export default angular
  .module('meanApp.services', [])
  .service('AssetLoaderService', AssetLoaderService)
  .name;
